import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend'; // primary - use cache
import HttpApi from 'i18next-http-backend'; // fallback - http load
import LanguageDetector from 'i18next-browser-languagedetector';
import {asAPIUrl} from "./utility/fetch-util";

const translationAPI = asAPIUrl('/api/user/react/translations/{{lng}}');

i18n
    // for loading translations - chained backends (see below)
    .use(Backend)
    // detect user language after login (options below)
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next - for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        detection: {
            order: ['sessionStorage'],
            lookupSessionStorage: 'userLocale',
            convertDetectedLanguage: (bynxLocale) => bynxLocale.replace('_', '-'),
        },
        backend: {
            backends: ((process.env.NODE_ENV && process.env.NODE_ENV === 'development')
                ? [HttpApi]  //no storage in dev localhost
                : [LocalStorageBackend, HttpApi]), // primary, secondary backend  in test and prod
            backendOptions: ((process.env.NODE_ENV && process.env.NODE_ENV === 'development')
                ? [{
                    /* options for development backend - file from server */
                    loadPath: translationAPI,
                }]
                : [{
                    /* options for primary backend - cached file */
                    prefix: 'i18next_dp_',
                    expirationTime: 24 * 60 * 60 * 1000,  //1 day //TODO tie in with session expiry
                    defaultVersion: '',    //TODO set with main version to refresh?
                    store: typeof window !== 'undefined' ? window.localStorage : null
                }, {
                    /* options for secondary backend - file from server */
                    loadPath: translationAPI,
                }]),
        },
        fallbackLng: 'en-GB',  //english GB if lang not supported
        debug: (!!(process.env.NODE_ENV && process.env.NODE_ENV === 'development')),
        interpolation: {
            escapeValue: false, //not needed for react as it escapes by default
        },
    });

export default i18n;